import { useRouter } from 'next/router';

function getPathWithoutQueryAndHash(asPath: string) {
  return asPath.split('?')[0].split('#')[0];
}

export function useProfileCurrentPath() {
  const router = useRouter();

  return getPathWithoutQueryAndHash(router.asPath);
}
